"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.specialRefsWithQueries = exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _modal = _interopRequireDefault(require("../../../core/modal"));
var _inputOnBlur = _interopRequireDefault(require("../../../core/input-on-blur"));
var _input = _interopRequireDefault(require("../../../core/input"));
var _getQueryResponse = _interopRequireDefault(require("../../../../entryFunctions/getQueryResponse"));
var _PanCelticEntry = _interopRequireDefault(require("../../../core/PanCelticEntry"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Where a secondary race or "special" is associcated with a give race, then paddlers may be asked a supplementary question, eg name of school.

const specialRefsWithQueries = exports.specialRefsWithQueries = ['PANC', 'SCSC', 'BOAT', 'SELN'];
const boatResponses = [{
  description: 'Yes please, I would like to borrow a boat',
  value: '(BB)'
}, {
  description: 'No thanks, I have my own',
  value: ''
}];
const selectionResponses = [{
  description: 'No thanks',
  value: ''
}, {
  description: 'Yes, I wish to be considered for selection and I understand that I meet the Nationality requirements to represent GBR and GBR is my first choice nation for selection. I also confirm that I meet the eligibility requirements set out in the appropriate section of the selection policy.',
  value: 'Selection'
}];
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Are you entering this race as part of your national Pan-Celtic team? Please indicate your country");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "Are you entering this race as part of Scottish Schools? If so please enter the name of your school (otherwise just click done)");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "Will you need to borrow an appropriate boat?");
var _ref4 = /*#__PURE__*/_react.default.createElement("p", null);
var _ref5 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Please confirm the categories you wish to be considered for?");
class SpecialQueriesModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      PANC: null,
      SCSC: null,
      BOAT: null,
      SELN: null,
      SELNage: null
    });
    _defineProperty(this, "_onSetResponse", (value, specialRef) => {
      this.setState({
        [specialRef]: value
      });
    });
    _defineProperty(this, "_getResponse", specialRef => {
      return this.state[specialRef] || (0, _getQueryResponse.default)(specialRef, this.props.entry.queryResponses);
    });
    _defineProperty(this, "_onValid", () => {
      if (this._getResponse('SELN') === 'Selection' && !this._getResponse('SELNage')) return false; // need second question to be answered
      return true;
    });
    _defineProperty(this, "_getRaceSpecialRefs", () => {
      return this.props.race.specialRefs.filter(ref => specialRefsWithQueries.includes(ref));
    });
    _defineProperty(this, "_onDone", () => {
      const specialRefs = this._getRaceSpecialRefs();
      return Promise.all(specialRefs.map(sRef => {
        let thisResponse = this._getResponse(sRef);
        if (sRef === 'SELN' && thisResponse.length) thisResponse = thisResponse + '(' + this._getResponse('SELNage') + ')';
        this.props.onUpsertQueryResponse(this.props.entry.id, sRef, thisResponse);
      }));
    });
    _defineProperty(this, "_isEligibleForSelection", tierRef => {
      if (tierRef === 'CSLX') return true; // rules for kayak cross are fairly loose so ask everyone

      const entry = this.props.entry;
      const ageCat = entry.ageCategoryID && entry.ageCategoryID.substring(0, 1);
      if (entry.rankingDivisionRef === 'P') return true; //anyone in prem is eligible for selection
      //juniors in div 1 are eligible if they are ranked high enough.
      // bibNumber is equivalent to start of year rankings at this level
      if (entry.rankingDivisionRef === '1' && ageCat === 'J') {
        if (entry.classRef === 'K1M' && entry.bibNumber <= 24) return true;
        if (entry.classRef === 'C1M' && entry.bibNumber <= 14) return true;
        if (entry.classRef === 'K1W' && entry.bibNumber <= 10) return true;
        if (entry.classRef === 'C1W' && entry.bibNumber <= 3) return true;
      }
      return false;
    });
    _defineProperty(this, "_getSelectionCategoryResponses", () => {
      const entry = this.props.entry;
      const ageCategory = entry.ageCategoryID && entry.ageCategoryID.substring(0, 1);
      const selectionCategoryResponses = [];
      if (ageCategory === 'S' || ageCategory === 'M') {
        selectionCategoryResponses.push({
          description: 'Senior only',
          value: 'S'
        });
      } else if (ageCategory === 'U' || entry.rankingDivisionRef === 'P') {
        selectionCategoryResponses.push({
          description: 'Senior/U23 only',
          value: 'S,U23'
        });
      }
      if (ageCategory === 'J') {
        selectionCategoryResponses.push({
          description: 'Junior only',
          value: 'J'
        });
        if (entry.rankingDivisionRef === 'P') selectionCategoryResponses.push({
          description: 'Senior/U23 and Junior',
          value: 'S,U23,J'
        });
      }
      return selectionCategoryResponses;
    });
  }
  render() {
    // we are only interested in specialRefs that have queries.
    const race = this.props.race;
    const specialRefs = this._getRaceSpecialRefs();
    const entry = this.props.entry;
    if (!entry || !entry.id || !specialRefs.length) return null;
    // If we've already recorded a response for every special ref then don't display modal
    // if selection specialRef then ignore responses for those not eligible.
    if (specialRefs.every(s => s === 'SELN' && !this._isEligibleForSelection(race.competitionDivision.tierRef) || entry.queryResponses.filter(qr => qr.specialRef === s).length)) return null;
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: race.competition.competitionName + ' - ' + race.raceName,
      buttons: /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "primary",
        onClick: this._onDone,
        disabled: !this._onValid()
      }, "Done")
    }, !specialRefs.includes('PANC') ? null : /*#__PURE__*/_react.default.createElement("div", null, _ref, /*#__PURE__*/_react.default.createElement(_PanCelticEntry.default, {
      entry: entry,
      onSetResponse: this._onSetResponse,
      queryResponse: this._getResponse('PANC')
    })), !specialRefs.includes('SCSC') ? null : /*#__PURE__*/_react.default.createElement("div", null, _ref2, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "text",
      name: "SCSC",
      value: this._getResponse('SCSC'),
      onChange: this._onSetResponse
    })), !specialRefs.includes('BOAT') ? null : /*#__PURE__*/_react.default.createElement("div", null, _ref3, boatResponses.map(o => /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Radio",
      name: "BOAT",
      value: o.value,
      checked: this._getResponse('BOAT') === o.value,
      onChange: this._onSetResponse,
      label: o.description
    }))), !specialRefs.includes('SELN') || !this._isEligibleForSelection(race.competitionDivision.tierRef) ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
      className: "lead"
    }, 'Do you wish to be considered for selection in ' + (race.competitionDivision.tierRef === 'CSLX' ? 'Kayak Cross ' : 'Slalom ') + race.eventRef + '?'), selectionResponses.map(o => /*#__PURE__*/_react.default.createElement(_input.default, {
      key: o.value,
      type: "Radio",
      name: "SELN",
      value: o.value,
      checked: this._getResponse('SELN') === o.value,
      onChange: this._onSetResponse,
      label: o.description
    })), !this.state.SELN ? null : /*#__PURE__*/_react.default.createElement("div", {
      style: {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      }
    }, _ref4, _ref5, this._getSelectionCategoryResponses().map(o => /*#__PURE__*/_react.default.createElement(_input.default, {
      key: o.value,
      type: "Radio",
      name: "SELNage",
      value: o.value,
      checked: this._getResponse('SELNage') === o.value,
      onChange: this._onSetResponse,
      label: o.description
    })))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(SpecialQueriesModal, "partialQueries", {
  Race: {
    id: true,
    raceName: true,
    eventRef: true,
    specialRefs: true,
    competitionDivision: {
      tierRef: true
    },
    competition: {
      id: true,
      competitionName: true
    }
  }
});
var _ref6 = _mergeBqlQueries({
  id: true,
  ageCategoryID: true,
  rankingDivisionRef: true,
  classRef: true,
  bibNumber: true,
  queryResponses: {
    id: true,
    specialRef: true,
    response: true
  }
}, _PanCelticEntry.default.partialQueries.Entry);
var _default = exports.default = (0, _reactBicycle.connect)(SpecialQueriesModal, props => ({
  ["entry(entryID:" + JSON.stringify(props.entryID) + ")"]: _ref6
}), (client, props) => ({
  onUpsertQueryResponse(entryID, specialRef, response) {
    return client.update('QueryResponse.upsert', {
      entryID,
      specialRef,
      response
    });
  }
}));